const STORAGE_KEY = 'npc_signup_agent';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function normalizeAgentCode(value) {
  return String(value || '').trim().slice(0, 64);
}

export function saveSignupAgent(agent) {
  const agentCode = normalizeAgentCode(agent?.agentCode || agent?.agent_code || agent?.lineCode || agent?.line_code);
  if (!agentCode) return null;

  const payload = {
    agentCode,
    agentName: String(agent?.agentName || agent?.agent_name || agent?.name || '').trim().slice(0, 100),
    referralToken: String(agent?.referralToken || agent?.referral_token || '').trim(),
    verifiedAt: Date.now(),
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (_) {}
  return payload;
}

export function readSignupAgent() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const agentCode = normalizeAgentCode(parsed?.agentCode);
    const verifiedAt = Number(parsed?.verifiedAt || 0);
    if (!agentCode || !verifiedAt || Date.now() - verifiedAt > MAX_AGE_MS) {
      clearSignupAgent();
      return null;
    }
    return {
      agentCode,
      agentName: String(parsed?.agentName || '').trim().slice(0, 100),
      referralToken: String(parsed?.referralToken || '').trim(),
      verifiedAt,
    };
  } catch (_) {
    clearSignupAgent();
    return null;
  }
}

export function clearSignupAgent() {
  try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
}
